/**
 * The gender to show for an order's patient, with the line-level fallback.
 *
 * Gender lives on patients.gender for a record-backed order. A record-less
 * order (patient_id NULL: legacy rows and reorders) has no patients row, so
 * the wizard persists it on the primary line's configuration.gender, and the
 * update_order_patient_gender RPC writes there too whenever it cannot touch a
 * record (none, or one filed under another clinic). Without the fallback the
 * order detail page printed "-" for exactly the orders whose gender had just
 * been edited. Same precedence as the prescription Excel exporter: the record
 * first, then the line.
 */
export interface OrderPatientGenderSource {
  patient: { gender: string | null } | null;
  lines: ReadonlyArray<{ configuration: unknown }>;
}

export function orderPatientGender(order: OrderPatientGenderSource): string | null {
  const cfg = (order.lines[0]?.configuration ?? {}) as Record<string, unknown>;
  const cfgGender = typeof cfg.gender === 'string' ? cfg.gender : null;
  return order.patient?.gender ?? cfgGender;
}
